// extracted by mini-css-extract-plugin
export var activeLang = "Footer-module--activeLang--f8022";
export var column = "Footer-module--column--e4ed6";
export var columnTitle = "Footer-module--columnTitle--cee19";
export var footer = "Footer-module--footer--2d913";
export var footerContainer = "Footer-module--footerContainer--6aa47";
export var hline = "Footer-module--hline--65486";
export var language = "Footer-module--language--e22c4";
export var languages = "Footer-module--languages--bf323";
export var lastItem = "Footer-module--lastItem--0dd5c";
export var link = "Footer-module--link--e0d8f";
export var logoWrapper = "Footer-module--logoWrapper--0d1aa";
export var paths = "Footer-module--paths--67ede";
export var trademark = "Footer-module--trademark--e4483";